/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  GamoraControllerContextIdentifier,
  GamoraFoundationGlueListenerType,
  GamoraFoundationNodeArgs,
  debugCreate,
} from '@ver.id/libs.internal.gamora';
import {
  HoruzProtocolChulakClientStateEvent,
  HoruzProtocolChulakClientStateInvoker,
  HoruzProtocolChulakClientStateInvokerAbortInput,
} from './enums.js';
import { HoruzProtocolChulakClientStateBase } from './base.js';
import { HoruzProtocolChulakClientStateContext } from '../context.js';
import { HoruzProtocolChulakClientStateMap } from '../../statemap.js';
import { HoruzProtocolChulakCloseCode } from '../../codes.js';
import { IHoruz } from '../../../../horuz.js';
const debug = debugCreate({
  namespace: 'horuz:protocols:chulak:states:client:abort',
});
/**
 * Client
 *
 * Abort state
 * @public
 */
export class HoruzProtocolChulakClientStateAbort extends HoruzProtocolChulakClientStateBase<
  typeof HoruzProtocolChulakClientStateMap,
  HoruzProtocolChulakClientStateContext,
  IHoruz
> {
  constructor(args: GamoraFoundationNodeArgs) {
    super(args);
  }

  /**
   * Enter state
   */
  override async $enter(
    clientStateContext: HoruzProtocolChulakClientStateContext,
  ): Promise<void> {
    debug.log('(_onEventEnter): Aborted chulak session. ');

    try {
      // Invoke abortion handler
      await this.$emit(
        clientStateContext.contextIdentifier,
        HoruzProtocolChulakClientStateEvent.Aborted,
        clientStateContext,
        {
          error: clientStateContext.stateContextRegistry.lastError,
        } as HoruzProtocolChulakClientStateInvokerAbortInput,
      );

      // Close ws
      if (clientStateContext.ws.readyState === clientStateContext.ws.OPEN) {
        if (clientStateContext.stateContextRegistry.lastError) {
          clientStateContext.ws.close(
            clientStateContext.stateContextRegistry.lastError.code,
            clientStateContext.stateContextRegistry.lastError.reason,
          );
        } else {
          clientStateContext.ws.close(
            HoruzProtocolChulakCloseCode.PROTOCOL_UNKNOWN_ERROR,
          );
        }
      }
    } catch (e: any) {
      debug.trace(e?.message, e?.stack);
      this._tryHandleException(clientStateContext, e);
    }
  }

  /**
   * Exit state
   */
  override async $exit(): Promise<void> {}

  /**
   * Register invokers
   */
  on(
    contextIdentifier: GamoraControllerContextIdentifier,
    name: typeof HoruzProtocolChulakClientStateEvent.Aborted,
    listener: (
      clientStateContext: HoruzProtocolChulakClientStateContext,
      input: HoruzProtocolChulakClientStateInvokerAbortInput,
    ) => Promise<void>,
  ): this;
  on<K extends keyof typeof HoruzProtocolChulakClientStateInvoker>(
    contextIdentifier: GamoraControllerContextIdentifier,
    name: K,
    listener: GamoraFoundationGlueListenerType,
  ): this {
    return super.$on(contextIdentifier, name, listener);
  }
}
